// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3Mcma","addWidgetButton":"Header_addWidgetButton__3Xlby","dashboardTabs":"Header_dashboardTabs__I-hmf","active":"Header_active__h4DPr"};